<template>
  <div v-if="data" class="app flex-row align-items-center">
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <table class="mainTable m-3 p-4 h-100 w-100">
      <div class="noPrint">
        <v-row cols="6" class="mt-3 mb-3" style="background-color: lightblue">
          <v-col cols="1"></v-col>
          <v-col cols="3">
            <b-form-group label="تاریخ صدور پیش فاکتور:">
              <b-form-input v-model="myDate" type="text"> </b-form-input>
              <v-switch
                v-model="hasSignature"
                label="امضا (در صورت وجود) نمایش داده شود"
              ></v-switch>
              <v-switch
                v-model="removeZeroCount"
                label="اقلام با تعداد 0 را حذف کن"
              ></v-switch>
            </b-form-group>
          </v-col>
          <v-col cols="4">
            <b-form-group :label="'نوع استعلام: ' + printTypes[printType]">
              <br />
              <b-btn
                variant="link"
                :href="printLinks.otherPrintLink"
                v-if="printType != 'technical'"
                >مشاهده استعلام فنی</b-btn
              >
              <b-btn
                variant="link"
                :href="printLinks.otherPrintLink"
                v-if="printType != 'full'"
                >مشاهده استعلام مالی</b-btn
              >
              <b-btn
                variant="link"
                :href="printLinks.noPrice"
                v-if="printType != 'noPrice'"
                >مشاهده استعلام مالی بدون قیمت</b-btn
              >
              <br />
              <b-btn
                variant="link"
                :href="printLinks.customerFull"
                v-if="printType == 'full'"
                >استعلام مالی ویژه مشتری</b-btn
              >
              <b-btn
                variant="link"
                :href="printLinks.customerTechnical"
                v-if="printType == 'technical'"
                >استعلام فنی ویژه مشتری</b-btn
              >
              <b-btn
                variant="link"
                :href="printLinks.customerNoPriceFull"
                v-if="printType == 'noPrice'"
                >استعلام مالی بدون قیمت ویژه مشتری</b-btn
              >
            </b-form-group>
          </v-col>
          <v-col cols="3">
            <v-select
              :items="[0, 1, 2, 3, 4, 5]"
              label="حاشیه"
              segmented
              overflow
              editable
              target="#target"
              v-model="computedMarginValue"
            ></v-select>
            <br />
            <v-select
              :items="sizeItems"
              label="سایز فونت جدول"
              segmented
              overflow
              editable
              target="#target"
              v-model="computedTableValue"
            ></v-select>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
      </div>
      <div style="border: 0px solid">
        <thead
          v-if="
            data.productsTemplate != 'pken' && data.productsTemplate != 'pken2'
          "
          style="font-family: iransans"
        >
          <hr />
          <v-row id="header" :class="computedMarginBottom">
            <v-col cols="1">
              <b-img src="/img/brand/small.png" class="w-100" />
            </v-col>
            <v-col style="font-size: 120% !important" cols="3"></v-col>
            <v-col style="font-size: 120% !important" cols="3">
              <b-img src="/img/brand/big.png" class="w-100" />
            </v-col>
            <v-col style="font-size: 120% !important" cols="3"></v-col>
            <v-col class="m-auto" cols="2">
              <v-row>تاریخ: {{ myDate }}</v-row>
              <v-row class="mt-3">شماره استعلام: {{ data.orderCode }}</v-row>
              <v-row class="mt-3">کد اقتصادی: 8578-3359-4113</v-row>
            </v-col>
          </v-row>
          <hr />
        </thead>
        <thead
          v-if="
            data.productsTemplate == 'pken' || data.productsTemplate == 'pken2'
          "
        >
          <hr />
          <div dir="ltr" style="font-family: Tahoma">
            <v-row id="header" :class="computedMarginBottom">
              <v-col cols="1">
                <img src="/img/brand/small.png" class="w-100" />
              </v-col>
              <v-col style="font-size: 120% !important" cols="3"></v-col>
              <v-col style="font-size: 120% !important" cols="3">
                <img src="/img/brand/big.png" class="w-100" />
              </v-col>
              <v-col style="font-size: 120% !important" cols="3"></v-col>
              <v-col cols="2">
                <v-row
                  >Date:
                  {{
                    moment(myDate, "jYYYY/jMM/jDD").format("YYYY-MMM-DD")
                  }}</v-row
                >
                <v-row>Reference No.: {{ data.orderCode }}</v-row>
              </v-col>
            </v-row>
          </div>
          <hr />
        </thead>
        <tfoot
          v-if="
            data.productsTemplate != 'pken' && data.productsTemplate != 'pken2'
          "
          style="font-family: iransans"
        >
          <hr />
          <v-row class="mt-1">
            <v-col style="font-size: 120% !important" cols="6"
              >دفتر: تهران، خیابان پاسداران، برج سفید، طبقه 6، واحد 601</v-col
            >
            <v-col style="font-size: 120% !important" cols="3"
              >تلفن: 22542000 - 22547800</v-col
            >
            <v-col style="font-size: 120% !important" cols="3"
              >فاکس: 22553905</v-col
            >
          </v-row>
          <v-row class="mb-2">
            <v-col style="font-size: 120% !important" cols="6"
              >کارخانه: جاده خراسان، بعد از پلیس‌راه شریف‌آباد، شهرک صنعتی عباس
              آباد</v-col
            >
            <v-col style="font-size: 120% !important" cols="3"
              >تلفن: 36423241-2</v-col
            >
            <v-col style="font-size: 120% !important" cols="3"
              >فاکس: 36423680</v-col
            >
          </v-row>
          <hr />
        </tfoot>
        <tfoot
          v-if="
            data.productsTemplate == 'pken' || data.productsTemplate == 'pken2'
          "
          dir="ltr"
          style="font-family: Tahoma"
        >
          <hr />
          <v-row class="mt-1">
            <v-col
              style="font-size: 120% !important; text-align: left"
              cols="7"
              dir="ltr"
              >Head Office: No. 601, 6th floor, Borj Sefid, Pasdaran Ave.,
              Tehran, Iran</v-col
            >
            <v-col
              style="font-size: 120% !important; text-align: left"
              cols="3"
              dir="ltr"
              >Tel: +98(21)22542000 - +98(21)22547800</v-col
            >
            <v-col
              style="font-size: 120% !important; text-align: left"
              cols="2"
              dir="ltr"
              >Fax: +98(21)22553905</v-col
            >
          </v-row>
          <v-row class="mb-2">
            <v-col
              cols="7"
              dir="ltr"
              style="font-size: 120% !important; text-align: left"
              >Factory: Abbasabad Industrial Zone, After Sharifabad Police
              Station, Tehran-Khorasan Rd., Tehran, Iran</v-col
            >
            <v-col
              style="font-size: 120% !important; text-align: left"
              cols="3"
              dir="ltr"
              >Tel: +98(21)36423241-2</v-col
            >
            <v-col style="font-size: 120% !important; text-align: left" cols="2"
              >Fax: +98(21)36423680</v-col
            >
          </v-row>
          <hr />
        </tfoot>
        <tbody
          v-if="
            data.productsTemplate != 'pken' && data.productsTemplate != 'pken2'
          "
        >
          <v-row :class="computedMarginTop + ' mx-3'">
            <div
              v-html="
                data.customerTerms.replace('فنی / مالی', printTypes[printType])
              "
            />
          </v-row>
          <hr />
          <b-table
            v-if="!busy"
            responsive
            show-empty
            head-variant="light"
            :items="removeZeroCount ? orderItems.filter(x=>x.number) : orderItems"
            :fields="myFields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :style="
              'font-size: ' +
              computedTableValue +
              'px !important;font-family: Tahoma !important'
            "
          >
            <template v-slot:head()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  color: #990000;
                "
              >
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                dir="ltr"
                :style="
                  'text-align: center; vertical-align: middle; font-size: ' +
                  computedTableValue +
                  'px;'
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div
                dir="ltr"
                :style="
                  'text-align: center; vertical-align: middle; font-size: ' +
                  computedTableValue +
                  'px;'
                "
              >
                {{ data.index + 1 }}
              </div>
            </template>
            <template v-slot:cell(totalPrice)="data">
              <div
                dir="ltr"
                :style="
                  'text-align: center; vertical-align: middle; font-size: ' +
                  computedTableValue +
                  'px;'
                "
              >
                {{ sarmadNumber2(data.item.number * data.item.perPrice) }}
              </div>
            </template>
            <template v-slot:cell(perPrice)="data">
              <div
                dir="ltr"
                :style="
                  'text-align: center; vertical-align: middle; font-size: ' +
                  computedTableValue +
                  'px;'
                "
              >
                {{ sarmadNumber2(data.item.perPrice * 1) }}
              </div>
            </template>
            <template v-slot:cell(number)="data">
              <div
                dir="rtl"
                :style="
                  'text-align: center; vertical-align: middle; font-size: ' +
                  computedTableValue +
                  'px;'
                "
              >
                {{ parseInt(data.item.number * 1).toLocaleString() }}
                {{ measurementUnit }}
              </div>
            </template>
          </b-table>
          <hr v-if="printType == 'full'" />
          <div
            v-if="printType == 'full'"
            style="page-break-inside: avoid; font-size: 120% !important"
          >
            <v-row>
              <v-col style="font-size: 120% !important" cols="3"
                >قیمت کل اقلام:</v-col
              >
              <v-col cols="3" style="font-size: 120% !important"
                >{{
                  orderItems.length > 0
                    ? sarmadNumber2(
                        orderItems
                          .map(
                            (x) =>
                              (x.perPrice
                                ? x.perPrice.toString().replace(/\s/g, "")
                                : 0) *
                              (x.number
                                ? x.number.toString().replace(/\s/g, "")
                                : 0)
                          )
                          .reduce((a, b) => a + b)
                      )
                    : "--"
                }}
                {{ currency || "ریال" }}</v-col
              >
            </v-row>
            <v-row v-if="parseFloat(packagingCost) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >هزینه بسته‌بندی:</v-col
              >
              <v-col style="font-size: 120% !important" cols="3"
                >‌{{ sarmadNumber2(packagingCost) }}
                {{ currency || "ریال" }}</v-col
              >
            </v-row>
            <v-row v-if="parseFloat(transportCost) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >هزینه حمل:</v-col
              >
              <v-col style="font-size: 120% !important" cols="3"
                >‌{{
                  parseFloat(sarmadNumber(transportCost)).toLocaleString()
                }}
                {{ currency || "ریال" }}</v-col
              >
            </v-row>
            <v-row v-if="parseFloat(personCost) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >هزینه بازرسی شخص ثالث:</v-col
              >
              <v-col style="font-size: 120% !important" cols="3"
                >{{ parseFloat(sarmadNumber(personCost)).toLocaleString() }}
                {{ currency || "ریال" }}</v-col
              >
            </v-row>

            <v-row v-if="parseFloat(coatingCost) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >هزینه پوشش دهی:</v-col
              >
              <v-col cols="3"
                >{{
                  orderItems.length > 0
                    ? parseFloat(
                        sarmadNumber(
                          orderItems
                            .map(
                              (x) =>
                                (x.perPrice
                                  ? x.perPrice.toString().replace(/\s/g, "")
                                  : 0) *
                                (x.number
                                  ? x.number.toString().replace(/\s/g, "")
                                  : 0)
                            )
                            .reduce((a, b) => a + b)
                        ) *
                          (coatingCost / 100)
                      ).toLocaleString()
                    : "--"
                }}
                {{ currency || "ریال" }}</v-col
              >
            </v-row>
            <v-row v-if="parseFloat(certificationCost) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >هزینه تست و صدور گواهینامه:‌</v-col
              >
              <v-col style="font-size: 120% !important" cols="3"
                >{{
                  parseFloat(sarmadNumber(certificationCost)).toLocaleString()
                }}
                {{ currency || "ریال" }}</v-col
              >
            </v-row>
            <v-row v-if="parseFloat(otherCost) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >سایر هزینه‌ها:‌</v-col
              >
              <v-col style="font-size: 120% !important" cols="3"
                >{{ parseFloat(sarmadNumber(otherCost)).toLocaleString() }}
                {{ currency || "ریال" }}</v-col
              >
            </v-row>
            <v-row v-if="parseFloat(discount) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3">تخفیف:</v-col>
              <v-col style="font-size: 120% !important" cols="3"
                >{{ parseFloat(sarmadNumber(discount)).toLocaleString() }}
                {{ currency || "ریال" }}</v-col
              >
            </v-row>
            <v-row
              v-if="
                discount +
                packagingCost +
                transportCost +
                personCost +
                certificationCost +
                otherCost
              "
            >
              <v-col style="font-size: 120% !important" cols="3">
                <strong>قیمت کل بدون مالیات:‌</strong>
              </v-col>
              <v-col style="font-size: 120% !important" cols="3">
                <strong>
                  {{
                    totalPriceVatExcluded(
                      orderItems,
                      discount,
                      packagingCost,
                      transportCost,
                      personCost,
                      certificationCost,
                      otherCost,
                      currency
                    )
                  }}
                </strong>
              </v-col>
            </v-row>
            <v-row v-if="parseFloat(vat) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >مالیات بر ارزش افزوده ({{ vat }}%):</v-col
              >
              <v-col style="font-size: 120% !important" cols="3">{{
                totalVat(
                  orderItems,
                  discount,
                  packagingCost,
                  transportCost,
                  personCost,
                  certificationCost,
                  otherCost,
                  currency,
                  vat
                )
              }}</v-col>
            </v-row>
            <hr />
            <v-row>
              <v-col style="font-size: 120% !important" cols="3">
                <strong>قیمت کل:‌</strong>
              </v-col>
              <v-col style="font-size: 120% !important" cols="3">
                <strong>
                  {{
                    totalPrice(
                      orderItems,
                      discount,
                      packagingCost,
                      transportCost,
                      personCost,
                      certificationCost,
                      otherCost,
                      currency,
                      vat
                    )
                  }}
                </strong>
              </v-col>
            </v-row>
            <!-- <v-row
              v-if="
                totalPriceNumeric(
                  orderItems,
                  discount,
                  packagingCost,
                  transportCost,
                  personCost,
                  certificationCost,
                  otherCost,
                  currency,
                  vat
                ) != data.price
              "
            >
              <v-col cols="3">
                <em>قیمت اعلامی به مشتری:‌</em>
              </v-col>
              <v-col cols="3">
                <em>
                  {{ data.price.toLocaleString() }}
                  {{ currency }}
                </em>
              </v-col>
              <v-col cols="6">
                <em>
                  قیمت ارسالی به مشتری با فرمول قدیمی و با مغایرت با قیمت فعلی
                  ثبت شده است.
                </em>
              </v-col>
            </v-row> -->
          </div>
          <v-row
            class="mb-3"
            v-if="printType == 'technical' || printType == 'noPrice'"
            style="font-size: 120%"
          >
            <v-col style="font-size: 120% !important" cols="3"
              >کل اقلام:
              {{
                orderItems.length > 0
                  ? orderItems
                      .map((x) => parseInt(x.number))
                      .reduce((a, b) => a + b)
                      .toLocaleString()
                  : "--"
              }}</v-col
            >
          </v-row>
          <hr />
          <v-row class="mt-3" style="page-break-inside: avoid">
            <v-col cols="8">
              <div
                style="font-family: Tahoma !important; font-size: 120%"
                v-html="data.terms"
              />
            </v-col>

            <v-col style="font-size: 120% !important" cols="3">
              <v-row class="h-100">
                <h3 style="text-align: center; align-self: center">
                  محمد حسینی
                  <br />مدیر عامل
                  <br />
                  <img
                    v-if="
                      role != 'tradeIntern' && data.orderSigned && hasSignature
                    "
                    src="../assets/images/sign.png"
                    class="w-100"
                  />
                  <br />
                  <img
                    v-if="
                      role != 'tradeIntern' && data.orderSigned && hasSignature
                    "
                    src="../assets/images/stamp.png"
                    class="w-50"
                    style="margin-top: -5px"
                  />
                </h3>
              </v-row>
            </v-col>
          </v-row>
        </tbody>
        <tbody
          v-if="
            data.productsTemplate == 'pken' || data.productsTemplate == 'pken2'
          "
        >
          <v-row dir="ltr" :class="computedMarginTop + ' mx-3'">
            <div
              dir="ltr"
              v-html="data.customerTerms"
              style="font-size: 120%; text-align: left"
            />
          </v-row>
          <hr />
          <b-table
            v-if="!busy"
            responsive
            show-empty
            head-variant="light"
            :items="removeZeroCount ? orderItems.filter(x=>x.number) : orderItems"
            :fields="myFields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :style="
              'font-size: ' +
              computedTableValue +
              'px !important;font-family: Tahoma !important'
            "
          >
            <template v-slot:head()="data">
              <div
                :style="
                  'text-align: center; vertical-align: middle; font-size: ' +
                  computedTableValue +
                  'px;'
                "
              >
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                dir="ltr"
                :style="
                  'text-align: center; vertical-align: middle; font-size: ' +
                  computedTableValue +
                  'px;'
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div
                dir="ltr"
                :style="
                  'text-align: center; vertical-align: middle; font-size: ' +
                  computedTableValue +
                  'px;'
                "
              >
                {{ data.index + 1 }}
              </div>
            </template>
            <template v-slot:cell(totalPrice)="data">
              <div
                dir="ltr"
                :style="
                  'text-align: center; vertical-align: middle; font-size: ' +
                  computedTableValue +
                  'px;'
                "
              >
                {{
                  parseFloat(
                    sarmadNumber(data.item.number * data.item.perPrice)
                  ).toLocaleString()
                }}
              </div>
            </template>
            <template v-slot:cell(perPrice)="data">
              <div
                dir="ltr"
                :style="
                  'text-align: center; vertical-align: middle; font-size: ' +
                  computedTableValue +
                  'px;'
                "
              >
                {{
                  parseFloat(
                    sarmadNumber(data.item.perPrice * 1)
                  ).toLocaleString()
                }}
              </div>
            </template>
            <template v-slot:cell(number)="data">
              <div
                dir="ltr"
                :style="
                  'text-align: center; vertical-align: middle; font-size: ' +
                  computedTableValue +
                  'px;'
                "
              >
                {{ parseInt(data.item.number * 1).toLocaleString() }}
                {{ measurementUnit }}
              </div>
            </template>
          </b-table>
          <hr v-if="printType == 'full'" />
          <div
            v-if="printType == 'full'"
            dir="ltr"
            style="
              page-break-inside: avoid;
              font-size: 120% !important;
              text-align: left;
              font-family: Tahoma;
            "
          >
            <v-row>
              <v-col style="font-size: 120% !important" cols="3"
                >Total Items Price:</v-col
              >
              <v-col cols="3" style="font-size: 120% !important"
                >{{
                  orderItems.length > 0
                    ? parseFloat(
                        sarmadNumber(
                          orderItems
                            .map(
                              (x) =>
                                (x.perPrice
                                  ? x.perPrice.toString().replace(/\s/g, "")
                                  : 0) *
                                (x.number
                                  ? x.number.toString().replace(/\s/g, "")
                                  : 0)
                            )
                            .reduce((a, b) => a + b)
                        )
                      ).toLocaleString()
                    : "--"
                }}
                {{ currency || "Rials" }}</v-col
              >
            </v-row>
            <v-row v-if="parseFloat(packagingCost) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >Packaging Costs:</v-col
              >
              <v-col style="font-size: 120% !important" cols="3"
                >‌{{
                  parseFloat(sarmadNumber(packagingCost)).toLocaleString()
                }}
                {{ currency || "Rials" }}</v-col
              >
            </v-row>
            <v-row v-if="parseFloat(transportCost) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >Transportation Costs:</v-col
              >
              <v-col style="font-size: 120% !important" cols="3"
                >‌{{
                  parseFloat(sarmadNumber(transportCost)).toLocaleString()
                }}
                {{ currency || "Rials" }}</v-col
              >
            </v-row>
            <v-row v-if="parseFloat(personCost) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >Third-Party Inspection Costs:</v-col
              >
              <v-col style="font-size: 120% !important" cols="3"
                >{{ parseFloat(sarmadNumber(personCost)).toLocaleString() }}
                {{ currency || "Rials" }}</v-col
              >
            </v-row>
            <v-row v-if="parseFloat(coatingCost) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >Coating Price:</v-col
              >
              <v-col cols="3"
                >{{
                  orderItems.length > 0
                    ? parseFloat(
                        sarmadNumber(
                          orderItems
                            .map(
                              (x) =>
                                (x.perPrice
                                  ? x.perPrice.toString().replace(/\s/g, "")
                                  : 0) *
                                (x.number
                                  ? x.number.toString().replace(/\s/g, "")
                                  : 0)
                            )
                            .reduce((a, b) => a + b)
                        ) *
                          (coatingCost / 100)
                      ).toLocaleString()
                    : "--"
                }}
                {{ currency || "Rials" }}</v-col
              >
            </v-row>
            <v-row v-if="parseFloat(certificationCost) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >Test and Certification Costs:‌</v-col
              >
              <v-col style="font-size: 120% !important" cols="3"
                >{{
                  parseFloat(sarmadNumber(certificationCost)).toLocaleString()
                }}
                {{ currency || "Rials" }}</v-col
              >
            </v-row>
            <v-row v-if="parseFloat(otherCost) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >Other Costs:‌</v-col
              >
              <v-col style="font-size: 120% !important" cols="3"
                >{{ parseFloat(sarmadNumber(otherCost)).toLocaleString() }}
                {{ currency || "Rials" }}</v-col
              >
            </v-row>
            <v-row v-if="parseFloat(discount) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >Discount:</v-col
              >
              <v-col style="font-size: 120% !important" cols="3"
                >{{ parseFloat(sarmadNumber(discount)).toLocaleString() }}
                {{ currency || "Rials" }}</v-col
              >
            </v-row>
            <v-row
              v-if="
                discount +
                packagingCost +
                transportCost +
                personCost +
                certificationCost +
                otherCost
              "
            >
              <v-col style="font-size: 120% !important" cols="3">
                <strong>Total Amount (VAT Excluded):‌</strong>
              </v-col>
              <v-col style="font-size: 120% !important" cols="3">
                <strong>{{
                  totalPriceVatExcluded(
                    orderItems,
                    discount,
                    packagingCost,
                    transportCost,
                    personCost,
                    certificationCost,
                    otherCost,
                    currency
                  )
                }}</strong>
              </v-col>
            </v-row>
            <v-row v-if="parseFloat(vat) > 0" class="mt-2">
              <v-col style="font-size: 120% !important" cols="3"
                >VAT ({{ vat }}%):</v-col
              >
              <v-col style="font-size: 120% !important" cols="3">{{
                totalVat(
                  orderItems,
                  discount,
                  packagingCost,
                  transportCost,
                  personCost,
                  certificationCost,
                  otherCost,
                  currency,
                  vat
                )
              }}</v-col>
            </v-row>
            <hr />
            <v-row>
              <v-col style="font-size: 120% !important" cols="3">
                <strong>Total Amount:‌</strong>
              </v-col>
              <v-col style="font-size: 120% !important" cols="3">
                <strong>
                  {{
                    totalPrice(
                      orderItems,
                      discount,
                      packagingCost,
                      transportCost,
                      personCost,
                      certificationCost,
                      otherCost,
                      currency,
                      vat
                    )
                  }}</strong
                >
              </v-col>
            </v-row>
            <!-- <v-row
              v-if="
                totalPriceNumeric(
                  orderItems,
                  discount,
                  packagingCost,
                  transportCost,
                  personCost,
                  certificationCost,
                  otherCost,
                  currency,
                  vat
                ) != data.price
              "
            >
              <v-col cols="3">
                <em>Initial Announced Query:‌</em>
              </v-col>
              <v-col cols="3">
                <em>
                  {{ data.price.toLocaleString() }}
                  {{ currency }}
                </em>
              </v-col>
              <v-col cols="6">
                <em>
                  Initial price had been calculated using old formula.
                </em>
              </v-col>
            </v-row> -->
          </div>
          <v-row
            class="mb-3"
            v-if="printType == 'technical' || printType == 'noPrice'"
            style="font-size: 120%"
          >
            <v-col style="font-size: 120% !important" cols="3"
              >Total Items:
              {{
                orderItems.length > 0
                  ? orderItems
                      .map((x) => parseInt(x.number))
                      .reduce((a, b) => a + b)
                      .toLocaleString()
                  : "--"
              }}</v-col
            >
          </v-row>
          <hr />
          <v-row class="mt-3" style="page-break-inside: avoid" dir="ltr">
            <v-col cols="8">
              <div
                dir="ltr"
                style="
                  font-family: Tahoma !important;
                  font-size: 120%;
                  text-align: left;
                "
                v-html="data.terms"
              />
            </v-col>

            <v-col style="font-size: 120% !important" cols="3">
              <v-row class="h-100">
                <h3 style="text-align: center; align-self: center">
                  Mohammad Hosseini
                  <br />CEO
                  <br />
                  <img
                    v-if="
                      role != 'tradeIntern' && data.orderSigned && hasSignature
                    "
                    src="../assets/images/sign.png"
                    class="w-100"
                  />
                  <br />
                  <img
                    v-if="
                      role != 'tradeIntern' && data.orderSigned && hasSignature
                    "
                    src="../assets/images/stamp.png"
                    class="w-50"
                    style="margin-top: -5px"
                  />
                </h3>
              </v-row>
            </v-col>
          </v-row>
        </tbody>
      </div>
    </table>
  </div>
</template>

<script>
import Axios from "axios";
import Vue from "vue";
import Var from "../../variables";
import router from "../router";
import moment from "moment-jalaali";
import prices from "../mixins/prices";

export default {
  mixins: [prices],

  data() {
    return {
      moment: moment,
      currency: "ریال",
      role: localStorage.role,
      currencyOptions: [
        { value: "دلار", text: "دلار", precision: 2 },
        { value: "USD", text: "USD", precision: 2 },
        { value: "$", text: "$", precision: 2 },
        { value: "یورو", text: "یورو", precision: 2 },
        { value: "Euro", text: "Euro", precision: 2 },
        { value: "€", text: "€", precision: 2 },
        { value: "ریال", text: "ریال", precision: 0 },
        { value: "Rials", text: "Rials", precision: 0 },
        { value: "یوآن", text: "یوآن", precision: 2 },
        { value: "Yuan", text: "Yuan", precision: 2 },
        { value: "¥", text: "¥", precision: 2 },
        { value: "درهم", text: "درهم", precision: 2 },
      ],
      data: "",
      vat: 9,
      packagingCost: 0,
      transportCost: 0,
      personCost: 0,
      coatingCost: 0,
      certificationCost: 0,
      otherCost: 0,
      discount: 0,
      extraDetails: false,
      myDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      fields1: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "#" },
      ],
      fields2: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "#" },
      ],
      fieldsen: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "index", label: "#" },
      ],
      fieldsen2: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "description", label: "Description" },
        { key: "index", label: "#" },
      ],
      fields1CI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "index", label: "#" },
      ],
      fields2CI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "index", label: "#" },
      ],
      fieldsenCI: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "index", label: "#" },
      ],
      fieldsen2CI: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "index", label: "#" },
      ],
      hasCustomerIndex: false,
      hasSizeStandard: true,
      myFields: [],
      orderItems: [],
      measurementUnit: "",
      printType: "full",
      printTypes: {
        full: "مالی",
        technical: "فنی",
        noPrice: "مالی بدون قیمت",
      },
      busy: true,
      printLinks: "",
      computedMarginValue: 3,
      computedTableValue: 11,
      sizeItems: [
        { value: 7, text: "---" },
        { value: 9, text: "--" },
        { value: 10, text: "-" },
        { value: 11, text: "استاندارد" },
        { value: 12, text: "+" },
        { value: 13, text: "++" },
        { value: 15, text: "+++" },
      ],
      hasSignature: true,
      removeZeroCount: false
    };
  },
  methods: {
    sarmadNumber2(data) {
      let temp1 = parseFloat(data).toFixed(
        this.currencyOptions.filter((x) => x.value == this.currency)[0]
          .precision
      );

      return parseFloat(temp1) ? parseFloat(temp1).toLocaleString() : "--";
    },

    sarmadNumber(data) {
      let temp1 = parseFloat(
        parseFloat(data).toFixed(
          this.currencyOptions.filter((x) => x.value == this.currency)[0]
            .precision
        )
      );
      return temp1 ? temp1 : 0;
    },
    getData() {
      this.busy = true;
      this.printType = this.$route.params.type;
      Axios.post(
        this.baseUrl + "/ppkpms/order/getInfo",
        {
          orderId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.data = res.data;
            if (res.data.measurementUnit) {
              if (res.data.measurementUnit == "کیلوگرم") {
                if (
                  this.data.productsTemplate == "pk1" ||
                  this.data.productsTemplate == "pk2"
                ) {
                  this.measurementUnit = "کیلوگرم";
                } else {
                  this.measurementUnit = "kg";
                }
              } else if (res.data.measurementUnit == "تن") {
                if (
                  this.data.productsTemplate == "pk1" ||
                  this.data.productsTemplate == "pk2"
                ) {
                  this.measurementUnit = "تن";
                } else {
                  this.measurementUnit = "ton";
                }
              }
            }
            this.orderItems = JSON.parse(this.data.orderItems);

            this.extraDetails = Boolean(
              this.orderItems.map((x) => x.details).reduce((a, b) => a + b)
            );

            this.vat = this.data.orderVat;
            this.packagingCost = this.data.packagingCost;
            this.transportCost = this.data.transportCost;
            this.personCost = this.data.personCost;
            this.coatingCost = this.data.coatingCost;
            this.certificationCost = this.data.certificationCost;
            this.otherCost = this.data.otherCost;
            this.discount = this.data.discount;
            this.hasSizeStandard = this.data.orderHasSizeStandard;
            this.hasCustomerIndex = this.data.hasCustomerIndex;
            this.currency = this.data.currency;

            ///////////////////////////////////////////////////////////////
            ///// DEFINE TABLE COLUMSN DUE TO AVAILABLE INFORMATION ///////
            ///////////////////////////////////////////////////////////////
            this.myFields = this.hasCustomerIndex
              ? this.data.productsTemplate == "pk1"
                ? this.fields1CI
                : this.data.productsTemplate == "pk2"
                ? this.fields2CI
                : this.formTemplate == "pken2"
                ? this.fieldsen2CI
                : this.fieldsenCI
              : this.data.productsTemplate == "pk1"
              ? this.fields1
              : this.data.productsTemplate == "pk2"
              ? this.fields2
              : this.formTemplate == "pken2"
              ? this.fieldsen2
              : this.fieldsen;

            if (!this.hasSizeStandard) {
              this.myFields = this.myFields.filter(
                (x) => x.key != "dimensionStandard"
              );
            }

            if (!this.extraDetails) {
              this.myFields = this.myFields.filter((x) => x.key != "details");
            }

            if (this.printType == "technical" || this.printType == "noPrice") {
              this.myFields = this.myFields
                .filter((x) => x.key != "perPrice")
                .filter((x) => x.key != "totalPrice");
            }

            ///////////////////////////////////////////////////////////////
            ///// DEFINE TABLE COLUMSN DUE TO AVAILABLE INFORMATION ///////
            ///////////////////////////////////////////////////////////////

            this.printLinks = {
              otherPrintLink:
                "/" +
                localStorage.role +
                "/printPreview/" +
                (this.printType == "full" ? "technical" : "full") +
                "/" +
                this.$route.params.id,

              Technical:
                "/" +
                localStorage.role +
                "/printPreview/technical/" +
                this.$route.params.id,
              Full:
                "/" +
                localStorage.role +
                "/printPreview/full/" +
                this.$route.params.id,
              noPrice:
                "/" +
                localStorage.role +
                "/printPreview/noPrice/" +
                this.$route.params.id,

              customerTechnical:
                "/printPreview/technical/" + this.$route.params.id,

              customerFull: "/printPreview/full/" + this.$route.params.id,

              customerNoPriceFull:
                "/printPreview/noPrice/" + this.$route.params.id,
            };

            this.busy = false;
            if (
              this.data.status == "تایید تعیین قیمت توسط مشتری" ||
              this.data.status == "اعلام تعیین قیمت به مشتری"
            ) {
              setTimeout(() => {
                window.print();
              }, 1000);
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },
  mounted() {
    this.getData();
  },
  computed: {
    computedMarginTop() {
      let margin = "mt-" + this.computedMarginValue;
      return margin;
    },
    computedMarginBottom() {
      let margin = "mb-" + this.computedMarginValue;
      return margin;
    },
  },
};
</script>
<style>
p {
  font-family: iransans;
}

td {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
}

@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>

<style scoped>
p,
div {
  font-size: 11px;
  line-height: 1rem;
}

thead {
  background-color: white;
  color: black;
}

@media print {
  @page {
    margin: 0;
    size: a4 landscape;
    font-size: 30%;
    text-color: black;
  }

  .noPrint {
    display: none !important;
  }

  body {
    margin: 1.6cm;
  }

  table {
    border: 1px solid;
  }

  table.mainTable {
    border: 0px !important;
  }

  /* tfoot:after {
    counter-increment: page;
    content: "صفحه " counter(page);
  } */
}
</style>
